import { Directive, effect, ElementRef, inject } from '@angular/core'
import { _objectKeys } from '@naturalcycles/js-lib'
import { BucketEditType, getBucketEditsOfType } from '@naturalcycles/shared'
import { getState } from '@src/app/core/store/signalStore.js'

@Directive({
  selector: 'img[src]',
  standalone: true,
})
export class ExperimentableImageDirective {
  private el: ElementRef<HTMLImageElement> = inject(ElementRef)

  update = effect(() => {
    const assignments = getState().experiment.assignments
    const edits = Object.fromEntries(
      _objectKeys(assignments)
        .flatMap(e => {
          const assignment = assignments[e]
          if (!assignment) {
            return []
          }
          return getBucketEditsOfType(assignment, BucketEditType.Image)
        })
        .map(curr => [curr.id, curr.replacementUrl]),
    )
    const src = this.el.nativeElement.src.replace(new RegExp(`^${window.location.origin}`), '')
    const edit = edits[src]
    this.el.nativeElement.src = edit || this.el.nativeElement.src
  })
}
